export default [
	{
		name: 'Главная',
		icon: 'ti-panel',
		collapsed: false,
		children: [
			{
				name: 'Рабочий стол',
				path: '/index'
			}
		]
	},
	{
		name: 'Приборы учёта',
		icon: 'ti-panel',
		collapsed: false,
		children: [
			{
				name: 'Показания с ПУ',
				path: '/meter'
			}
		]
	}
]



// WEBPACK FOOTER //
// ./src/sidebarLinks.js